module.exports = __webpack_public_path__ + "img/default_logo.9367d2c2.svg";